import myoshLogo from './myosh-logo.svg';
import myoshLogoSquare from './myosh-logo-square.svg';

export const Logo = { myoshLogoSquare, myoshLogo };
